import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { userHasAccess } from '../../../utils/userHasAccess';
import { SUB_MODULES } from '../../../constants/subModulesConstants';

export default function DocumentationSelect ({ open, onClose, onSelect }) {

    const handleClose = () => onClose();

    const documentationOptions = [
      { value: "vitals", label: "Vitals", hidden: !userHasAccess(SUB_MODULES.VITALS, 2) },
      { value: "inventory", label: "Inventory", hidden: !userHasAccess(SUB_MODULES.INVENTORY, 2) },
      { value: "appointment", label: "Appointment", hidden: !userHasAccess(SUB_MODULES.APPOINTMENTS, 2) }, // excluded
      { value: "prescription", label: "Prescription", hidden: !userHasAccess(SUB_MODULES.PRESCRIPTION, 2) },
      { value: "invoice", label: "Invoice", hidden: !userHasAccess(SUB_MODULES.INVOICE, 2) },
      { value: "waiver", label: "Waiver", hidden: !userHasAccess(SUB_MODULES.WAIVER, 2) },
    ];

    const [documentation, setDocumentation] = useState("");

    const handleChange = (e) => {
      onSelect(e.target.value);
    };

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogContent>
                <FormControl fullWidth sx={{ minHeight: 300 }}>
                  <InputLabel>
                    Select Documentation
                  </InputLabel>
                  <Select
                    value={documentation}
                    label="Select Documentation"
                    onChange={handleChange}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250, // adjust as needed
                        },
                      },
                    }}
                  >
                    {documentationOptions
                    .filter(opt => !opt.hidden) // exclude flagged options
                    .map(opt => (
                      <MenuItem key={opt.value} value={opt.value} sx={{ my: 1 }}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}